export const docTypes = [
  { label: "DOC.TRIB.NO.DOM.SIN.RUC", value: 0 },
  { label: "DOC. NACIONAL DE IDENTIDAD", value: 1 },
  { label: "CARNÉ DE EXTRANJERIA", value: 4 },
  { label: "REG.UNICO DE CONTRIBUYENTES", value: 6 },
  { label: "PASAPORTE", value: 7 },
  { label: "CED.DIPLOMATICA DE IDENTIDAD", value: "A" },
];
